import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';

export type FeatureServiceIntervalClasses = 'itemContainer' | 'itemLabel' | 'itemValue';

const featureServiceIntervalStyles = makeStyles<ISpcTheme, FeatureServiceIntervalClasses>(
  theme => ({
    itemContainer: {
      padding: '5px 0',
      display: 'flex',
      justifyContent: 'space-between',
      color: `${theme.palette.secondary.dark}`,
    },
    itemLabel: {},
    itemValue: {
      fontSize: theme.typography.fontSM,
      fontFamily: theme.typography.fontFamily,
    },
  }),
  { name: 'Customise_Feature_ServiceInterval' },
);

export default featureServiceIntervalStyles;
